import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconPbs20X = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_2018_6411)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M8.41086 21.1605V19.8281L11.9457 16.3629C12.2837 16.0215 12.5654 15.7183 12.7908 15.4531C13.0162 15.188 13.1852 14.9311 13.2979 14.6825C13.4106 14.4339 13.467 14.1688 13.467 13.8871C13.467 13.5656 13.394 13.2905 13.2482 13.0618C13.1024 12.8298 12.9019 12.6508 12.6467 12.5248C12.3914 12.3989 12.1014 12.3359 11.7766 12.3359C11.4419 12.3359 11.1485 12.4055 10.8967 12.5447C10.6448 12.6806 10.4492 12.8745 10.31 13.1264C10.1741 13.3783 10.1062 13.6783 10.1062 14.0263H8.3512C8.3512 13.38 8.49869 12.8182 8.79367 12.3409C9.08865 11.8636 9.49466 11.4941 10.0117 11.2322C10.5321 10.9704 11.1287 10.8395 11.8015 10.8395C12.4842 10.8395 13.0842 10.9671 13.6012 11.2223C14.1182 11.4775 14.5193 11.8272 14.8043 12.2713C15.0927 12.7154 15.2369 13.2225 15.2369 13.7926C15.2369 14.1738 15.1639 14.5483 15.0181 14.9162C14.8723 15.2841 14.6154 15.6918 14.2475 16.1392C13.8829 16.5866 13.3708 17.1285 12.7113 17.7649L10.9563 19.5497V19.6193H15.391V21.1605H8.41086ZM18.5976 13.5241L20.1388 16.343L21.7049 13.5241H23.609L21.3072 17.3423L23.6488 21.1605H21.7546L20.1388 18.4112L18.538 21.1605H16.6289L18.9556 17.3423L16.6886 13.5241H18.5976Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2018_6411",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			fill: "none"
		})
	}) })]
});
export default SvgIconPbs20X;
